import axios from 'axios';
import qs from 'qs';
const API_URL = `${process.env.VUE_APP_API_HOST}/api`;
//BEGIN LOGIN

const getAuthToken = () => localStorage.getItem('jwttoken');

const authInterceptor = (config) => {
    const token = getAuthToken();
    if(token) {
        config.headers['Authorization'] = "Bearer" + token;
        config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });
    }
    return config;
}

let config = {
    baseURL: API_URL,
    timeout: 60 * 1000, // Timeout
};

const Axios = axios.create(config);

Axios.interceptors.request.use(authInterceptor);



function login(email, password, remember_me) {
    const url = `${API_URL}/account/login`;
    return Axios.post(url, {email, password, remember_me});
}
function logout() {
    delete Axios.defaults.headers.Authorization;
    localStorage.removeItem("jwttoken")
    localStorage.removeItem("userEmail")
    return Promise.resolve('logout')
}
//END LOGIN
//BEGIN MAP
function search(search) {
    let url = `${API_URL}/map/search/postal-code-suggestions?query=`;
    return Axios.get(url + search)
}
function fetchLayers() {
    let url = `${API_URL}/map/layers`;
    return Axios.get(url);
}
function fetchLocations(servicesId, circle) {
    let url = `${API_URL}/map/locations`;
    let params = {services: servicesId, circle: circle};

    // let request = Axios.create({paramsSerializer: params => qs.stringify(params)});
    return Axios.get(url, {params});

}

function updateLocation(id, data) {
    let url = `${API_URL}/map/location/${id}/update-settings`;
    return Axios.post(url, data)
}
function removeAddresses(id) {
    let url = `${API_URL}/map/location/${id}/remove-addresses`;
    return Axios.post(url)
}
function fetchDrivingZone(id, minutes) {
    let params = {minutes: minutes}
    let url = `${API_URL}/map/location/${id}/driving-zone-isochrone`;
    return Axios.get(url, {params})
}
//END MAP

//BEGIN Addresses
function fetchAddresses(params) {
    let url = `${API_URL}/map/addresses`;


    // let request = Axios.create({paramsSerializer: params => qs.stringify(params)});

    return Axios.get(url, {params});

}
//END Addresses

//BEGIN Tools
function uploadFile(file) {
    Axios.defaults.headers.common = {
        'Content-Type': 'multipart/form-data'
    };
    let url = `${API_URL}/tools/parse-addresses`;
    return Axios.post(url, file)
}
function geocodeAddresses(data) {
    let url = `${API_URL}/tools/geocode-addresses`;
    return Axios.post(url, data)
}
function pdfReportLocation(data) {
    let url = `${API_URL}/tools/location-pdf-report`;
    return Axios.get(url, { params: data });
}
function xlsxReportLocation(data) {
    let url = `${API_URL}/tools/location-xlsx-report`;
    return Axios.get(url, { params: data });
}
function pdfReportCircle(circle) {
    let url = `${API_URL}/tools/circle-pdf-report`;
    let params = {circle: circle};
    return Axios.get(url, {params});
}
function xlsxReportCircle(circle) {
    let url = `${API_URL}/tools/circle-xlsx-report`;
    let params = {circle: circle};
    return Axios.get(url, {params});
}
//END Tools




export {
    login,
    logout,
    search,
    fetchLayers,
    fetchLocations,
    fetchAddresses,
    updateLocation,
    uploadFile,
    geocodeAddresses,
    pdfReportLocation,
    xlsxReportLocation,
    pdfReportCircle,
    xlsxReportCircle,
    removeAddresses,
    fetchDrivingZone
};